<template>
  <div id="app">
    <el-container>
      <el-header height="150px"><div class="header">
        <img class="header_logo" src="../../../assets/home/home_purchase/yhyj3_03.png"/>
      </div></el-header>
      <el-main><div class="main dingdanye_dayanshi_qiangzhi_dingti">

        <div class="main_dingdan">
          <div class="main_dingdan_top">
            <div class="main_dingdan_top_text">
              <span v-if="application.shop">店铺:{{application.shop.shop_name}}</span>
            </div>
          </div>
          <el-row  :gutter="1" style="margin-top: 24px">
<!--            {{dd_item}}-->
            <el-col :xs="8" :sm="3" :md="3" :lg="3" :xl="3">
              <div class="dingdan_text1">订单：</div>
            </el-col>
            <el-col :xs="20" :sm="20" :md="20" :lg="20" :xl="20">
              <div class="main_dingdan_xinxitop">
                <el-row :gutter="10">
                  <el-col :xs="8" :sm="13" :md="13" :lg="13" :xl="13">
                    <div class="main_dingdan_xinxitop_tetx" style="margin-left: 11px">方案信息</div></el-col>
                  <el-col :xs="4" :sm="3" :md="3" :lg="3" :xl="3">
                    <div class="main_dingdan_xinxitop_tetx">数量</div>
                  </el-col>
                  <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4">
                    <div class="main_dingdan_xinxitop_tetx1">类型</div>
                  </el-col>
                  <el-col :xs="8" :sm="4" :md="4" :lg="4" :xl="4">
                    <div class="main_dingdan_xinxitop_tetx1">标价(元)</div></el-col>
                </el-row>

              </div>
              <div class="main_dingdan_neirong">
                <el-row :gutter="10">
                  <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
                    <img class="main_dingdan_neirong_img" :src="url+'/storage/'+application.pic " />
                  </el-col>
                  <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                    <div class="main_dingdan_neirong_text">{{application.title}}</div>
                  </el-col>
                  <el-col  :xs="5" :sm="5" :md="5" :lg="5" :xl="5" style="margin-top: 20px">
                    <el-input-number size="mini" value="1" :disabled="true" ></el-input-number>
                  </el-col>
                  <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4">
                    <div class="main_dingdan_neirong_text1">{{application.category.title}}</div>
                  </el-col>
                  <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4">
                    <div class="main_dingdan_neirong_text1">{{application.price}}</div>
                  </el-col>
                </el-row>
              </div>
<!--              <div class="main_dingdan_di">-->
<!--                <div class="main_dingdan_di_tishi">-->
<!--&lt;!&ndash;                  温馨提示：等待卖家确认订单&ndash;&gt;-->
<!--                </div>-->
<!--                <div class="main_dingdan_di_zongjine">-->
<!--                  货品总金额:<span class="main_dingdan_di_zongjine1">{{application.price}}</span>元</div>-->
<!--              </div>-->
            </el-col>
          </el-row>
<!--          <div class="main_dingdan_fege"></div>-->

<!--          <el-row :gutter="1" style="margin-top: 24px">-->
<!--            <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">-->
<!--              <div class="dingdan_text1" style="margin-top: -1px">交易方式：</div>-->
<!--            </el-col>-->
<!--            <el-col :xs="21" :sm="21" :md="21" :lg="21" :xl="21">-->
<!--              <div class="main_danbao">-->
<!--                <div class="main_danbao_text">-->
<!--                  担保交易-->
<!--                </div>-->
<!--                <img class="main_danbao_img" src="../../../assets/home/home_purchase/yhyj2_13.png" />-->

<!--              </div>-->
<!--              <div style="width: 100%;height: 38px"></div>-->
<!--            </el-col>-->
<!--          </el-row>-->
        </div>
<!--        <div class="main_heji">-->
<!--          <div class="zongji">-->
<!--          <span class="main_heji_text1 heji_1">总计:</span>-->
<!--          <span class="main_heji_text1 heji_2">货品种类：1种</span>-->
<!--          <span class="main_heji_text1 heji_3">数量总计：1件</span>-->
<!--            <span class="main_heji_text1 heji_5">{{ application.price }}元</span>-->
<!--            <span class="main_heji_text1 heji_4">货品总金额：</span>-->
<!--          </div>-->
<!--          <div class="heji">-->
<!--            <div class="heji_text">-->
<!--              应付总额：-->
<!--              <span class="heji_text2">{{ application.price }}</span>-->
<!--              元-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
        <div class="main_post">
          <div class="post_right">
            <div @click="posy" class="post_right_text" style="cursor:pointer;">提交订单</div>
          </div>


          <span class="yingfu_text2">{{ application.price }}元</span>
          <span class="yingfu_text1">应付总额：</span>
        </div>
      </div>

      </el-main>
      <el-footer height="300px">
        <el-row class="footer footer_bottom">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <div class="footer_width">
              <div class="glzy_top">
                <a class="xuanzhong wenzi" href="">
                  <span class="footer_text2 footer_gyyyj_left">关于仪海仪家</span>
                </a>
                <a class="xuanzhong wenzi" href="">
                  <span class="footer_text2 footer_lxwm_left">联系我们</span>
                </a>
                <a class="xuanzhong wenzi" href="">
                  <span class="footer_text2 footer_lxwm_left">著作权与商标声明</span>
                </a>
                <a class="xuanzhong wenzi" href="">
                  <span class="footer_text2 footer_lxwm_left">隐私政策</span>
                </a>
              </div>
              <div class="glzy_bottom">
                <span class="footer_text2 ">
                  Copyright@2020 海粟智链（青岛）科技有限公司
                  版权所有鲁ICP备 19060515号-1</span>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-footer>
    </el-container>
  </div>
</template>
<script>
import QRCode from 'qrcodejs2'
export default {
  name: 'App',
  data:function(){
    return{
      dialogVisible: false,
      beizhu:'',
      is_open:{
        sousuo:1,
        lanmu:1,
      },
      textarea:'',
      // options: regionDataPlus,
      diqu:'',
      xiangxi:'',
      list:'',
      shuliang:'',
      jibuqi:'1',
      radio:1,
      dizhi_list:'',
      dz_queren:1,
      xz_dizhi:'',
      xinzeng_name:'',
      xinzeng_ssq:'',
      xinzeng_phone:'',
      xinzeng_xiangxi:'',
      checked:false,
      fukuan_shijian:false,
      url : '',
      dd_neirong:'',
      dd_neirong_zuida:'',
      dd_zhi:0,
      dd_zongjia:0,

      // 应用方案
      application:null,
    }
  },
  methods:{
    init(){
      if (localStorage.getItem("uid")==''){
       // this.$router.push("user.html#/");
        window.location = 'user.html#/'
      }
      var t = this
      t.dd_neirong = t.$store.state.DbSource

      t.url = window.config.api_url
      if (t.$route.params.id){
        t.api_data()


      }
    },

    fnahui(){
      this.$router.go(-1);
    },
    qrCode() {
      this.dialogVisible = true;
      console.log(this.radio,this.radio1)
      var qrcode = ''
      console.log(qrcode)
      this.$nextTick(function () {
        document.getElementById("qrcode").innerHTML = "";
        qrcode = new QRCode("qrcode", {
          width: 150,
          height: 150,
          text: "二维码内容1223",
          colorDark: "#000000",
          colorLight: "#ffffff"
        });
      });
    },
    api_data(){

      var t = this
      var url = window.config.api_url+'/college/application/'+t.$route.params.id
      t.axios.get(url).then(res=>{
        if (!res.data.status){
          t.application = res.data.info
        }else{

          //todo
          t.$message({
            message: '应用方案不存在',
            type: 'error',
            onClose:function(){
              t.$router.go(-1)
            }
          });
        }

      })
    },


    posy(){
      var t = this
      var url = window.config.api_url+'/user/application/order/create'
      var formData = new FormData();
      var id = localStorage.getItem("uid")

      formData.append('token', id );
      formData.append('application_program_id', this.application.id );

      t.axios.post(url,formData).then(res=>{

        if ( !res.data.status ){
            window.location.href= "#/payment/application/"+res.data.order_id;

        }
      })
    },


  },
  created() {
    this.init()
  }
}
</script>
<style lang="less">
.main_text{
  .el-radio__inner:hover {
    border-color: #EF4F3F!important;
  }
  .el-radio__input.is-checked .el-radio__inner {
    border-color: #EF4F3F!important;
    background: #EF4F3F!important;
  }
}
.shezhimoren_yangshigenggai{
  .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #EF4F3F!important;
    border-color: #EF4F3F!important;
  }
  .el-checkbox__inner:hover {
    border-color: #EF4F3F!important;
  }
}
.dingdanye_dayanshi_qiangzhi_dingti{
.el-textarea__inner:focus {
  outline: 0;
  border-color: #EF4F3F!important;
}
.el-input.is-active .el-input__inner, .el-input__inner:focus {
  border-color: #EF4F3F!important;
    outline: 0;
  }
  .el-cascader .el-input .el-input__inner:focus, .el-cascader .el-input.is-focus .el-input__inner {
    border-color: #EF4F3F!important;
  }
  .el-cascader-node.in-active-path, .el-cascader-node.is-active, .el-cascader-node.is-selectable.in-checked-path {
    color: #EF4F3F!important;
    font-weight: 700;
  }
}
.dingdanchuangjian_xuanzhong_lika_qiangzhi_tihuan{
  .el-cascader-node.in-active-path, .el-cascader-node.is-active, .el-cascader-node.is-selectable.in-checked-path {
    color: #EF4F3F!important;
    font-weight: 700;
  }
}
</style>
<style lang="less" scoped>
@import "../../../../node_modules/element-ui/lib/theme-chalk/display.css";
//@head_text : Source Han Sans CN;
@font-face {

}
@import "../../../assets/css/home";

.el-footer {
  background-color: #FFFFFF;
  color: #333;
  //text-align: center;
  padding: 0 0;
  //line-height: 60px;
}

.el-main {
  background-color: #f4f4f4;
  color: #333;
  //text-align: center;
  padding: 0 0;
  //line-height: 500px;
}

.el-header {
  background: #f4f4f4;
  padding: 0 0;
  //border-bottom: #4E6EF2 solid 3px;
}
#app {

  width: 100%;

  .header{
    height: 100%;
    width: 80%;
    max-width: 1200px;
    margin-right: auto;
    margin-left: auto;
    .header_logo{
      margin-top: 50px;
    }
  }
  .main{
    height: 100%;
    width: 80%;
    max-width: 1200px;
    margin-right: auto;
    margin-left: auto;
    .main_dizhixuanze{
      width: 100%;
      height: 178px;
      background: #FFFFFF;
      border-radius: 3px;
      margin-top: 20px;
    }
    .main_shxindizhi{
      width: 100%;
      //height: 420px;
      position: relative;
      background: #FFFFFF;
      border-radius: 3px;
      .main_shxindizhi_qurenxinxi{
        float: left;
        width: 107px;
        height: 30px;
        background: #EF4F3F;
        border-radius: 3px;
        margin-bottom: 20px;
        .main_shxindizhi_qurenxinxi_text{
          //width: 83px;
          text-align: center;
          //height: 14px;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 30px;
        }
      }
      .main_shxindizhi_img{
        float: left;
        //line-height: 30px;
        margin-top: 9px;
        margin-left: 22px;
      }
      .main_shxindizhi_text{
        //width: 83px;
        //height: 12px;
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #C6241D;
        line-height: 30px;
      }
      .shxindizhi_left{
        margin-left: 13px;
      }
      .shxindizhi_left_text{
        float: right;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #555555;
        line-height: 32px;
        margin-right: 28px;
      }
      .shxindizhi_left_text2{
        float: right;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #555555;
        line-height: 32px;
        margin-right: 12px;
      }
      .shxindizhi_left_text3{
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #666666;
        margin-left: 4px
      }
    }
    .main_dingdan{
      margin-top: 29px;
      //height: 462px;
      width: 100%;
      background: #FFFFFF;
      .main_dingdan_top{
        width: 100%;
        height: 40px;
        background: #E2EDF8;
        .main_dingdan_top_text{
          //width: 142px;
          //height: 14px;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 600;
          color: #333333;
          line-height: 40px;
          margin-left: 12px;
        }
      }
      .main_dingdan_xinxitop{
        width: 100%;
        height: 42px;
        background: #F9FBFF;
        border: 1px solid #E2EDF8;
        .main_dingdan_xinxitop_tetx{
          //width: 56px;
          //height: 14px;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #333333;
          line-height: 50px;
        }
        .main_dingdan_xinxitop_tetx1{
          //width: 56px;
          //height: 14px;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #333333;
          line-height: 50px;
          text-align: center;
        }
      }
      .main_dingdan_neirong{
        width: 100%;
        height: 86px;
        background: #F9FBFF;
        border: 1px solid #E2EDF8;
        .el-input-number--mini{
          width: 100px;
          margin-left: 30px;
        }
        .main_dingdan_neirong_img{
          //width: 60px;
          margin-left: 13px;
          margin-right: 18px;
          height: 60px;
        }
        .main_dingdan_neirong_text{
          //width: 215px;
          //height: 32px;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #333333;
          //line-height: 18px;
        }
        .main_dingdan_neirong_text1{
          //width: 61px;
          text-align: center;
          //height: 13px;
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #333333;
          line-height: 65px;
        }
      }
      .main_dingdan_di{
        //width: 1028px;
        width: 100%;
        height: 80px;
        background: #F9FBFF;
        border: 1px solid #E2EDF8;
        .main_dingdan_di_tishi{
          //width: 182px;
          //height: 14px;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #333333;
          margin-left: 10px;
          margin-top: 10px;
          float: left;
          //line-height: 100px;
        }
        .main_dingdan_di_zongjine{
          margin-right: 15px;
          margin-top: 10px;
          float: right;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #333333;
          //line-height: 100px;
          .main_dingdan_di_zongjine1{
            //width: 66px;
            //height: 14px;
            font-size: 18px;
            font-family: Source Han Sans CN;
            font-weight: 500;
            color: #FF6000;
            //line-height: 100px;
          }
        }
      }
      .main_dingdan_fege{
        //width: 1144px;
        height: 1px;
        background: #E1E1E1;
        width: 92%;
        margin-left: 4%;
        margin-top: 25px;
      }
      .dingdan_text1{
        //width: 40px;
        //height: 14px;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #999999;
        //line-height: 100px;
        margin-top: 10px;
        margin-left: 25px;
      }
      .main_danbao{
        position: relative;
        width: 120px;
        height: 36px;
        background: #FFFFFF;
        border: 1px solid #EF4F3F;
        .main_danbao_text{
          //width: 55px;
          //height: 14px;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #333333;
          line-height: 36px;
          text-align: center;
        }
        .main_danbao_img{
          position: absolute;
          margin-top: -21px;
          margin-left: 91px;
        }
      }
    }
    .main_heji{
      margin-top: 11px;
      width: 100%;
      height: 134px;
      background: #FEF8E1;
      border: 1px solid #FBE1A3;
      .zongji{
        margin-top: 20px;
        .main_heji_text1{
          //width: 31px;
          //height: 14px;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #333333;
          //line-height: 100px;
        }
        .heji_1{
          margin-left: 25px;
        }
        .heji_2{
          margin-left: 70px;
        }
        .heji_3{
          margin-left: 10px;
        }
        .heji_4{
          float: right;
        }
        .heji_5{
          float: right;
          margin-right:55px;
        }
      }
      .heji{
        margin-top: 40px;
        .heji_text{
          float: right;
          margin-right: 35px;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #333333;
          //line-height: 100px;
          .heji_text2 {
            //width: 85px;
            //height: 18px;
            font-size: 22px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #EF4F3F;
            //line-height: 100px;
          }
        }
      }
    }
    .main_post{
      width: 100%;
      height: 60px;
      background: #FFFFFF;
      margin-bottom: 100px;
      margin-top: 20px;
      .post_right{
        width: 189px;
        height: 60px;
        background: #EF4F3F;
        float: right;
        .post_right_text{
          //width: 71px;
          //height: 17px;
          text-align: center;
          font-size: 18px;
          font-family: Source Han Sans CN;
          font-weight: 600;
          color: #FFFFFF;
          line-height: 60px;
        }
      }
      .yingfu_text1{
        float: right;
        //width: 60px;
        //height: 14px;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #333333;
        line-height: 60px;
      }
      .yingfu_text2{
        float: right;
        //width: 85px;
        //height: 18px;
        font-size: 22px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #EF4F3F;
        line-height: 60px;
        margin-right: 20px;
      }
    }
  }

  .footer {
    width: 100%;
    height: 255px;
    background: #FFFFFF;
    border-bottom: #E1E1E1 solid 1px;

    .footer_width {
      width: 80%;
      max-width: 1200px;
      margin-right: auto;
      margin-left: auto;

      .xdsk_top {
        position: relative;
        margin-top: 70px;

        .footer_img_xinshou {
          //margin-left: 5px;
          //margin-top: 13px;
          position: absolute;
          width: 50px;
          height: 50px;
        }

        .footer_img_duiwai {
          //margin-left: 155px;
          //margin-top: 13px;
          //margin-top: 13px;
          position: absolute;
          width: 50px;
          height: 50px;
        }

        .footer_img_shiming {
          //margin-left: 155px;
          //margin-top: 13px;
          position: absolute;
          width: 50px;
          height: 50px;
        }

        .footer_img_kefu {
          //margin-left: 155px;
          //margin-top: 13px;
          position: absolute;
          width: 50px;
          height: 50px;
        }

        .footer_xinshou_left {
          margin-left: 60px;
        }

        .footer_dsk_left {
          margin-left: 60px;
        }
      }

      .xdsk_bottom {
        margin-top: 38px;

        .footer_kongjian_left {
          margin-left: 17px;
        }

        .footer_jiaoyi_left {
          margin-left: 184px;
        }

        .footer_shiming_left {
        }

        .footer_tousu_left {
          margin-left: 520px;
        }

        .footer_changjian_left {
          margin-left: 945px;
        }
      }

      .glzy_top {
        margin-top: 51px;
        display:flex;
        justify-content:center;
        .footer_gyyyj_left {
          padding-right: 20px;
          border-right: #E1E1E1 solid 1px;
        }

        .footer_lxwm_left {
          margin-left: 29px;
          padding-right: 21px;
          border-right: #E1E1E1 solid 1px;
        }
      }

      .glzy_bottom {
        margin-top: 45px;
        text-align: center;
      }
    }
  }
  .footer_bottom {
    border-bottom: none;
    height: 223px;
  }
}
.youfudong{
  float: right;
}
.main_text{
  //width: 69px;
  //height: 14px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #666666;
  //line-height: 100px;
}
.main_text1{
  //width: 108px;
  //height: 12px;
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #333333;
  //line-height: 100px;
}
.head_text {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 550;
  color: #333333;
  line-height: 38px;
}

.footer_text1 {
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 150;
  color: #666666;
  //line-height: 30px;
}

.footer_text2 {
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #666666;
  //line-height: 30px;
}

.footer_text3 {
  font-size: 30px;
  font-family: Source Han Sans CN;
  font-weight: 550;
  color: #333333;
  //line-height: 30px;
}

.xuanzhong:hover {
  //color:#4E6EF2;
  text-decoration:none;
}
.wenzi{
  text-decoration:none;
}
</style>